import { createAxiosInstance } from "api/axiosConfig";

export const fetchMedications = async ({ search, page, tenant }) => {
  const axiosInstance = await createAxiosInstance();

  if (!search) {
    const response = await axiosInstance.get(
      `${tenant}/drugsfile/get?page=${page}`
    );

    return response.data;
  }

  const response = await axiosInstance.get(
    `${tenant}/drugsfile/search/${search.replace(/\//g, '-')}/get?page=${page}`
  );
  return response.data;
};
